import ProfileOrganizationDetailsForm from './ProfileOrganizationDetailsForm'

export default ProfileOrganizationDetailsForm
